export var CLASSNAME_PREFIX = 'av-iframe-container';
//# sourceMappingURL=componentConfig.js.map